import React from 'react';
import { FrownIcon } from 'lucide-react';
import { painPoints } from '../data/pains';
export function PainSection() {
  return <section className="w-full bg-cream py-16 sm:py-20" aria-labelledby="dolor-title" data-id="element-191" data-mp="38wlq4hzku8cg">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-192" data-mp="2ux4244u3uz45">
        <h2 id="dolor-title" className="max-w-3xl font-display text-3xl font-extrabold leading-tight tracking-tight text-petrol sm:text-4xl lg:text-5xl" data-id="element-193" data-mp="2yzquc6uoum1v">
          Hay una escena que se repite en miles de casas argentinas. Y nadie habla de ella.
        </h2>

        <div className="mt-12 grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-194" data-mp="2q0vr93mxxs2s">
          <div className="border-l-4 border-cta bg-white px-6 py-8 shadow-sm sm:px-10 sm:py-10" data-id="element-195" data-mp="2bbr8nlc8hlu5">
            <p className="font-display text-xl leading-relaxed text-petrol sm:text-[1.35rem] sm:leading-[1.6]" data-id="element-196" data-mp="2g9snfu2mmyzt">
              Es un domingo al mediodía. La familia está en la mesa. Hay asado. Hay ensalada rusa. Hay
              pan, hay vino, hay postre.
            </p>
            <p className="mt-5 font-display text-2xl font-extrabold leading-snug text-cta-hover sm:text-3xl" data-id="element-197" data-mp="3rm98z4030ev5">
              Y hay alguien que mira todo eso en silencio.
            </p>
            <div className="mt-5 space-y-4 text-lg leading-relaxed text-body" data-id="element-198" data-mp="5gccuh1dm7xm">
              <p data-id="element-199" data-mp="gpxo21zmhm6">
                No porque no tenga hambre. No porque no le guste. Sino porque desde el diagnóstico, cada
                comida se convirtió en una ecuación que no termina de entender.
              </p>
              <p className="italic text-body-muted" data-id="element-200" data-mp="33xyced1f51co">
                ¿Puedo comer esto? ¿Cuánto? ¿Lo combino con qué? ¿Me va a subir la glucosa igual?
              </p>
              <p data-id="element-201" data-mp="3io5pseckju6i">
                Y en lugar de disfrutar el asado, come un pedacito con culpa — o directamente no come.
              </p>
              <p className="font-semibold text-petrol" data-id="element-202" data-mp="2q59sl999xdva">
                Esa persona podes ser vos. O puede ser alguien que amás. Y eso no está bien.
              </p>
            </div>
          </div>

          <div className="space-y-5 text-lg leading-relaxed text-body" data-id="element-203" data-mp="p4louz910uvy">
            <p className="font-display text-2xl font-bold leading-snug text-petrol" data-id="element-204" data-mp="u2n8pmea0y8h">
              Desde el diagnóstico, nadie te preparó para esto.
            </p>
            <p data-id="element-205" data-mp="yueyhuplyzxk">
              El médico te dijo qué <span className="font-semibold text-petrol" data-id="element-206" data-mp="12uyx72ptyblt">no</span> comer. Nadie te
              dijo cómo seguir comiendo lo que te gusta.
            </p>
            <p data-id="element-207" data-mp="66smpz688ozm">
              Buscaste recetas online y encontraste ingredientes que no existen en Argentina,
              preparaciones de 2 horas y comida que parece castigo, no solución. Probaste dietas de
              internet que duran 3 días antes de que el aburrimiento gane.
            </p>
            <p data-id="element-208" data-mp="k60ql5dc4la5">
              Y en algún momento llegaste a creer que tener diabetes significa comer aburrido para
              siempre.
            </p>
            <p className="font-display text-2xl font-extrabold text-cta-hover" data-id="element-209" data-mp="1vj357uvvj0ro">No es verdad.</p>
            <p className="font-semibold text-petrol" data-id="element-210" data-mp="25ocgwu6rxmyu">
              El problema nunca fue la comida argentina. El problema fue que nadie te dio el sistema
              correcto.
            </p>
          </div>
        </div>

        <div className="mt-16 rounded-3xl bg-petrol px-6 py-10 text-white sm:px-10 sm:py-12" data-id="element-211" data-mp="1vwow3c4q346c">
          <h3 className="font-display text-2xl font-bold sm:text-3xl" data-id="element-212" data-mp="1rvd0mpz63oq8">
            ¿Te suena familiar alguna de estas situaciones?
          </h3>
          <ul className="mt-8 grid gap-x-10 gap-y-5 md:grid-cols-2" data-id="element-213" data-mp="1muyvpgsv4uwf">
            {painPoints.map(pain => <li key={pain} className="flex gap-3 text-base leading-relaxed text-white/85" data-id="element-214" data-mp="1cz5hlszhwtcj">
                <FrownIcon className="mt-0.5 h-5 w-5 shrink-0 text-sage" aria-hidden="true" data-id="element-215" data-mp="18xk17xnr5wxl" />
                <span data-id="element-216" data-mp="18zwomqca4zi1">{pain}</span>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-16 max-w-prose text-center" data-id="element-217" data-mp="37au1m9kl3m3s">
          <p className="font-display text-3xl font-extrabold leading-tight text-petrol sm:text-4xl" data-id="element-218" data-mp="33c32xy0gzwek">
            Eso no es vivir con diabetes. Eso es <span className="text-cta-hover" data-id="element-219" data-mp="3fdun4qmj54dh">sobrevivir</span> con
            diabetes.
          </p>
          <p className="mt-5 text-lg leading-relaxed text-body" data-id="element-220" data-mp="31e3ez6ip2i7e">
            Y hay una diferencia enorme. El problema nunca fuiste vos: el problema es que hasta hoy no
            existía un sistema hecho para tu cocina, tu cultura y tu forma de comer.
          </p>
          <p className="mt-6 inline-block border-b-4 border-cta pb-1 font-display text-2xl font-extrabold uppercase tracking-wide text-petrol" data-id="element-221" data-mp="2rmyzm5p3wvc1">
            Hasta hoy.
          </p>
        </div>
      </div>
    </section>;
}